// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__vN4gm","paymentName":"styles_paymentName__yE-Pt"};